/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.27.0
 */

import styled from 'styled-components';

import { ColorLink } from '@theme/default/colors/palette';

export const StepSelectMegaPowersStyled = styled.div`
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;

    & > div:not(:nth-child(4n), :nth-child(8n), :nth-child(12n)) {
        margin-right: 20px;
    }

    & > div {
        margin-bottom: 20px;
    }
`;

export const DangerouslySettedTextStyled = styled.span`
    & a {
        color: ${ColorLink};
    }

    * a:hover {
        text-decoration: underline;
    }
`;
